<template>
  <el-container class="layout-container">
    <el-header  class="topNavbar">
      <!-- <div class="logo" :class="{activeLogo:collapsed}"><img :src="collapsed?'./../assets/images/logo_small.png':'./../assets/images/logo_menu.png'"></div> -->
      <div class="logo" :class="{activeLogo:collapsed}" v-if="loginType == 1"><img class="img1" src="@/assets/images/logo_small.png" v-if="collapsed"><img class="img2" src="@/assets/images/logo_menu.png" v-else></div>
      <div class="logo" :class="{activeLogo:collapsed}" v-else><img class="img1" src="@/assets/images/train_smal.png" v-if="collapsed"><img class="img2" src="@/assets/images/train_menu.png" v-else></div>
      <div class="menu-toggle" @click="menuToggle">
        <i class="collapsedIcon" :class="!collapsed?'el-icon-arrow-left':'el-icon-arrow-right'"></i>
      </div>
      <ul class="nav">
        <li v-for="item in menuData" @click="navClick(item)" :key="item.id" :class="{active:item.menuName === currentNav}"><i class='iconfont' :class="item.menuPicCode"></i><br> {{item.menuName}}</li>
      </ul>
      <div class="rightNav">
        <el-select @change="hanleWorkAeae" v-model="currentWorkArea" filterable placeholder="请选择" style="margin-right: 30px;">
          <el-option
            v-for="item in workAreaOptions"
            :key="item.orgId"
            :label="item.orgName"
            :value="item.orgId">
          </el-option>
        </el-select>
        <el-badge :value="$store.state.MessagesNum" :max="99" :hidden="$store.state.MessagesNum === 0" style="margin-right: 30px;">
          <el-avatar class="avatarIcon" :size="30" icon="iconfont icontixing-" @click.native="msgClick()" ></el-avatar>
        </el-badge>
        <a href=" http://ailv.songguobaobao.com/sgbb/managept.html" target="_blank"><el-avatar class="avatarIcon" :size="30" icon="iconfont iconyonghucaozuozhinan" style="margin-right: 20px;"></el-avatar></a>
        <div class="cut"></div>
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{employeeInfo.fullName}}
            <!-- <el-avatar :size="40" class='iconfont iconlogout-user' @error="errorHandler" v-if="employeeInfo.headImg">
              <img :src="employeeInfo.headImg"/>
            </el-avatar> -->
            <div class="pic" :style="{backgroundImage: 'url('+ employeeInfo.headImg + ')'}" v-if="employeeInfo.headImg"></div>
            <i v-else class='iconfont iconlogout-user'></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="personal" v-if="loginType == 1">个人中心</el-dropdown-item>
            <el-dropdown-item command="courseCenter" v-if="loginType == 1">切换员工端</el-dropdown-item>
            <el-dropdown-item command="managBackground" v-else>切换管理后台</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>

    <el-container class="contentBox">
      <aside class="left-aside">
        <left-nav :leftNavList="leftNavList" :currentNav="currentNav" :collapsed="collapsed"></left-nav>
      </aside>
      <el-main id="mainContent" style="position:relative;overflow-x:hidden;overfow-y:auto;">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </el-main>
    </el-container>

  </el-container>
</template>
<script>
import leftNav from './leftNav'
import { getUserAndMenuByToken, chageWorkArea, verifyToken } from '@/api/homePage/api_homePage'
import {mapState} from 'vuex'
export default {
  name: 'home',
  components: {
    leftNav
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 根据 路由获取到 该路由的菜单权限
      vm.$store.commit('SET_CURRENTBUTTON', to.path)
    })
  },
  data () {
    return {
      menuData: [],
      currentNav: '主页',
      loading: false,
      leftNavList: [],
      currentWorkArea: '',
      workAreaOptions: [],
      collapsed: false,
      loginType: localStorage.getItem('loginType')
      // employeeInfo: {}
    }
  },
  watch: {
    $route: {
      handler (to, from) {
        this.$store.commit('SET_CURRENTBUTTON', to.path)
        if (to.query.isJump) {
          this.common()
        }
        // 根据当前路由，在菜单数组里面递归循环判断是否存在，不存在跳到无权限页面，页面按F5时或初始加载时，将此判断放在菜单请求回调里面
        if (this.isHavePermission(to.path, this.menuListAfter)) {
          this.$router.push({path: '/errorNopermission', query: {isJump: true}})
        }
      }
    }
    // ,
    // workArea: {
    //   handler (val) {
    //     if (val) {
    //       if (this.isHavePermission(this.$route.path, this.$store.state.systemMenu)) {
    //         this.$router.push({path: '/homePage', query: {isJump: true}})
    //       }
    //     }
    //   },
    //   immediate: true
    // }
  },
  computed: {
    ...mapState(['employeeInfo']),
    workArea () {
      return this.$store.state.employeeInfo.workArea
    },
    // 接口返回的数组 + 消息通知页面
    menuListAfter () {
      let arr = [...this.$store.state.systemMenu]
      arr.push({menuUrl: '/homePage/notification', menuType: 2, children: []})
      return arr
    }
  },
  created () {
    this.getUserAndMenuByToken()
  },
  methods: {
    errorHandler () {
      return true
    },
    // 查询当前路由是否在 菜单权限里面
    isHavePermission (path, data) {
      let flag = true
      for (let i = 0; i < data.length; i++) {
        if (!flag) {
          break
        }
        if (path === data[i].menuUrl && data[i].menuType === 2) {
          console.log('当前路由在接口返回菜单中存在')
          flag = false
          break
        } else if (data[i].children.length > 0 && data[i].menuType === 1) {
          flag = this.isHavePermission(path, data[i].children)
        }
      }
      return flag
    },
    hanleWorkAeae () {
      chageWorkArea(this.currentWorkArea).then(res => {
        // this.getUserAndMenuByToken()
        window.location.reload()
      })
    },
    async getUserAndMenuByToken () {
      await verifyToken().then(res => {
      })
      await getUserAndMenuByToken(localStorage.getItem('loginType')).then(res => {
        // 如果未配置权限，菜单为空，跳转到 提示页
        if (!(Array.isArray(res.systemMenu) && res.systemMenu.length > 0)) {
          this.$router.push('/errorNopermission')
        }
        this.menuData = res.systemMenu

        // this.employeeInfo = res.employeeInfo || {}
        this.workAreaOptions = res.workAreas || []
        this.currentWorkArea = res.employeeInfo.workArea

        this.$store.commit('SET_SYSTEMMENU', this.menuData)
        this.$store.commit('SET_USERINFO', res.employeeInfo)
        // this.$store.commit('SET_myPic', res.employeeInfo.headImg)
        // 根据 路由获取到 该路由的菜单权限
        this.$store.commit('SET_CURRENTBUTTON', this.$route.path)

        // 刷新时，根据当前路由，获取到左侧菜单的 集合
        this.common()

        // 页面第一次加载时，或切换工作域时第一次进来时，进行路由权限判断
        if (this.isHavePermission(this.$route.path, this.menuListAfter)) {
          this.$router.push({path: '/errorNopermission', query: {isJump: true}})
        }
      })

      // 查询 未读消息数量
      await this.$store.dispatch('getMessagesNum')
    },
    // 情形一 刷新时，根据当前路由，获取到左侧菜单的 集合
    // 情形二 其他页面点击跳转路由，点亮菜单
    common () {
      let currentRoute = this.menuData.filter((item) => {
        return item.menuUrl === ('/' + this.$route.path.split('/')[1])
      })
      this.leftNavList = currentRoute[0] ? currentRoute[0].children : []
      this.currentNav = currentRoute[0] ? currentRoute[0].menuName : ''
    },
    menuToggle () {
      this.collapsed = !this.collapsed
      this.$store.commit('SET_COLLAPSED', this.collapsed)
    },
    // 点击个人中心和 消息通知 一级菜单跳到 首页栏
    gotohomePageLevel () {
      this.currentNav = this.menuData[0].menuName
      this.leftNavList = this.menuData[0].children
    },
    navClick (item) {
      this.currentNav = item.menuName
      this.leftNavList = item.children

      let url = this.getMenuUrl(item)
      this.$router.push({
        path: url
      })
    },
    // 递归 查询 子级第一个 子菜单
    getMenuUrl (data) {
      let url = null
      if (url) {
        return url
      }
      if (data.menuType === 1 && data.children.length > 0) {
        url = this.getMenuUrl(data.children[0])
      } else if (data.menuType === 2) {
        url = data.menuUrl
      }
      return url
    },
    toggleSideBar () {
      this.$store.dispatch('ToggleSideBar')
    },

    logout () {
      this.$confirm('确认退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut')
      }).catch(() => {})
    },
    // 点击消息图标，跳转路由
    msgClick () {
      this.gotohomePageLevel()
      this.$router.push('/homePage/notification')
    },
    // 点击头像
    handleCommand (command) {
      if (command === 'personal') {
        this.gotohomePageLevel()
        this.$router.push('/homePage/personalCenter')
      } else if (command === 'logout') {
        this.logout()
      } else if (command === 'courseCenter') {
        localStorage.setItem('loginType', 0)
        getUserAndMenuByToken(localStorage.getItem('loginType')).then(res => {
          // 如果未配置权限，菜单为空，跳转到 提示页
          if (!(Array.isArray(res.systemMenu) && res.systemMenu.length > 0)) {
            this.$router.push('/errorNopermission')
          }
          this.menuData = res.systemMenu

          // this.employeeInfo = res.employeeInfo || {}
          this.workAreaOptions = res.workAreas || []
          this.currentWorkArea = res.employeeInfo.workArea

          this.$store.commit('SET_SYSTEMMENU', this.menuData)
          this.$store.commit('SET_USERINFO', res.employeeInfo)
          // this.$store.commit('SET_myPic', res.employeeInfo.headImg)
          // 根据 路由获取到 该路由的菜单权限
          this.$store.commit('SET_CURRENTBUTTON', this.$route.path)

          // 刷新时，根据当前路由，获取到左侧菜单的 集合
          this.common()
          this.gotohomePageLevel()
          this.$router.push('/courseCenter')
        })
      } else if (command === 'managBackground') {
        localStorage.setItem('loginType', 1)
        getUserAndMenuByToken(1).then(res => {
        // 如果未配置权限，菜单为空，跳转到 提示页
          if (!(Array.isArray(res.systemMenu) && res.systemMenu.length > 0)) {
            this.$router.push('/errorNopermission')
          }
          this.menuData = res.systemMenu

          // this.employeeInfo = res.employeeInfo || {}
          this.workAreaOptions = res.workAreas || []
          this.currentWorkArea = res.employeeInfo.workArea

          this.$store.commit('SET_SYSTEMMENU', this.menuData)
          this.$store.commit('SET_USERINFO', res.employeeInfo)
          // this.$store.commit('SET_myPic', res.employeeInfo.headImg)
          // 根据 路由获取到 该路由的菜单权限
          this.$store.commit('SET_CURRENTBUTTON', this.$route.path)

          // 刷新时，根据当前路由，获取到左侧菜单的 集合
          this.common()
          this.gotohomePageLevel()
          this.$router.push('/homePage')
        })
      }
      this.loginType = localStorage.getItem('loginType')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/* @media screen and (max-width: 1442px) {
  .topNavbar {
      height: 60px!important;
  }
} */

  /* @media screen and (min-width:600px) and (max-width:900px){
    body {background-color:#f5f5f5;}
  }
  @media screen and (min-width:1440px){
    body {background-color:#f5f5f5;}
  } */

</style>



// WEBPACK FOOTER //
// src/components/layout.vue